import React from 'react'

const IconPure = (props) => {
  return (
    <i
      className={`k-icon ${props.icon}`}
      {...props}
    />
  )
}

export default IconPure
